import callApi from 'utils/callApi';

// Requests
export function requestFetchWorkflowStates(payload) {
  return (payload && payload.limit && payload.offset)
    ? callApi(`workflow/state/?limit=${payload.limit}&offset=${payload.offset}`)
    : callApi('workflow/state/');
}

export function requestSearchWorkflowStates({ limit, offset, filters }) {
  return callApi('workflow/state/search/', 'POST', {
    filters,
    sort_by: [
      {
        name: 'Name',
        sort: 'asc',
      },
      {
        name: 'ID',
        sort: 'asc',
      },
    ],
    limit,
    offset,
  });
}



// WEBPACK FOOTER //
// ./src/redux/modules/workflowStates.js